'use client';

import { useState, useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';

function parseNumeric(s: string): number {
  return parseFloat(s.replace(/[^0-9.\-]/g, '')) || 0;
}

export function RollingValue({ value, className }: { value: string; className?: string }) {
  const [displayValue, setDisplayValue] = useState(value);
  const [prevValue, setPrevValue] = useState<string | null>(null);
  const [isRolling, setIsRolling] = useState(false);
  const [direction, setDirection] = useState<'up' | 'down'>('up');
  const prevValueRef = useRef(value);

  useEffect(() => {
    if (value !== prevValueRef.current) {
      const prev = prevValueRef.current;
      setPrevValue(prev);
      setDirection(parseNumeric(value) >= parseNumeric(prev) ? 'up' : 'down');
      setIsRolling(true);

      const timer = setTimeout(() => {
        setDisplayValue(value);
        prevValueRef.current = value;
      }, 50);

      const clearTimer = setTimeout(() => {
        setIsRolling(false);
        setPrevValue(null);
      }, 400);

      return () => {
        clearTimeout(timer);
        clearTimeout(clearTimer);
      };
    }
  }, [value]);

  const outClass = direction === 'up' ? 'animate-roll-up-out' : 'animate-roll-down-out';
  const inClass = direction === 'up' ? 'animate-roll-up-in' : 'animate-roll-down-in';

  return (
    <span className={cn("relative inline-flex overflow-hidden", className)}>
      {isRolling && prevValue !== null && (
        <span className={cn("absolute inset-0", outClass)} aria-hidden>
          {prevValue}
        </span>
      )}
      <span className={isRolling ? inClass : ""}>
        {displayValue}
      </span>
    </span>
  );
}
